<button type="button" [disabled]="(refreshState$ | async) || disabled" class="button--default" #refreshBtn>
    {{ (refreshState$ | async) ? refreshLabel : label }}
    <app-loading-spinner [hidden]="!(refreshState$ | async)" [displayMode]="LoadingSpinnerDisplayMode.INLINE"
        [size]="LoadingSpinnerSize.SMALL" [defaultHeight]="LoadingSpinnerDefaultHeight.NONE"
        [color]="LoadingSpinnerColorScheme.WHITE">
    </app-loading-spinner>
</button>
